export const DEFAULT_PLANNER_REASON = ({ definitionName }) =>
  `The \`hightouch_planner\` schema is used to store logs of previously-synced data. Before enabling the Lightning sync engine, you must first create this schema and grant Hightouch permission to read/write data. Try running this SQL snippet in your ${definitionName} console.`;

export const DEFAULT_AUDIT_REASON = ({ definitionName }) =>
  `The \`hightouch_audit\` schema is used to store logs of previously-synced data. Before enabling the Lightning sync engine, you must first create this schema and grant Hightouch permission to read/write data. Try running this SQL snippet in your ${definitionName} console.`;

export const DEFAULT_PLANNER_CODE_TITLE = () =>
  "Create hightouch_planner schema and grant access";

export const DEFAULT_AUDIT_CODE_TITLE = () =>
  "Create hightouch_planner schema and grant access";

// TODO this is a placeholder since we don't have public WHE source setup instructions yet.
export const DEFAULT_WAREHOUSE_EXPORT_REASON = () =>
  "Ensure that the source can export data to object storage.";

export const DEFAULT_WAREHOUSE_EXPORT_CODE_TITLE = () =>
  "Export data to object storage.";
